<template>
  <div class="pipe-popup">
    <div class="close" @click="onClose">×</div>
    <div id="content">
      <h3 style="font-weight: bold">{{ pipeName }}</h3>
      <div class="list">
        <div class="list-name">名称</div>
        <div class="list-value">{{pipe.name}}</div>
      </div>
      <div class="list">
        <div class="list-name">类型</div>
        <div class="list-value">{{pipe.type}}</div>
      </div>
      <div class="list">
        <div class="list-name">起始位置</div>
        <div class="list-value">
         {{pipe.start_X?`${pipe.start_X},${pipe.start_Y}`:''}}
        </div>
      </div>
      <div class="list">
        <div class="list-name">起点高程</div>
        <div class="list-value">{{pipe.start_Z||' - '}}m</div>
      </div>
      <div class="list">
        <div class="list-name">终止位置</div>
        <div class="list-value">
          {{pipe.end_X?`${pipe.end_X},${pipe.end_Y}`:''}}
        </div>
      </div>


      <div class="list">
        <div class="list-name">终点高程</div>
        <div class="list-value">{{pipe.end_z||' - '}}m</div>
      </div>
<!--      <div class="list">-->
<!--        <div class="list-name">埋深</div>-->
<!--        <div class="list-value">2m</div>-->
<!--      </div>-->
      <div class="list">
        <div class="list-name">管径</div>
        <div class="list-value">{{ pipe.caliber }}</div>
      </div>
      <div class="list">
        <div class="list-name">管材</div>
        <div class="list-value">{{ pipe.material }}</div>
      </div>
      <div class="list" v-if="pipe.pipe_type">
        <div class="list-name">给水类型</div>
        <div class="list-value">{{ pipe.pipe_type || " " }}</div>
      </div>
      <div class="list" v-if="pipe.burial_method">
        <div class="list-name">敷设类型</div>
        <div class="list-value">{{ pipe.burial_method || " " }}</div>
      </div>

      <div class="list">
        <div class="list-name">长度</div>
        <div class="list-value">{{ pipe.length || " " }}</div>
      </div>
<!--      <div class="list">-->
<!--        <div class="list-name">附属物</div>-->
<!--        <div class="list-value">无</div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import pipe_sc2Info from "@/components/model/pipe_sc2.json";
import pipe_scInfo from "@/components/model/pipe_sc.json";

export default {
  name: "pipe-popup",
  props: {
    name: String,
    id: String,
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    pipeName() {
      const nn = (this.name||'').split('_')[0]
      return this.name.indexOf('管段')==0 ?this.name:nn.split('管道')[0]+'管线'
      // if (
      //   this.name.includes("xianzhuang") ||
      //   this.name.includes("xinjianshengchan") ||
      //   this.name.includes("polySurface")
      // ) {
      //   return "新建生产管线";
      // } else if (this.name.includes("xinjianshuizha")) {
      //   return "新建排水管线";
      // } else if (this.name.includes("xinjianhuishou")) {
      //   return "新建回收管线";
      // } else if (this.name.includes("xinjianshuiyong")) {
      //   return "新建回用管线";
      // } else if (this.name.includes("xinjianpaini")) {
      //   return "新建排泥管线";
      // } else if (this.name.includes("工艺管道")) {
      //   return "生产管线";
      // } else {
      //   return "管线信息";
      // }
    },
    pipe() {
      if(this.name.indexOf('管段')==0){
        return pipe_sc2Info[Number(this.name.split('管段')[1])-1]||{};
      }else{
        return pipe_scInfo.find((item) => item.name2 === this.name||item.name === this.name)||{};
      }

    },
  },
  data() {
    return {
      // worldStart: this.data.worldStart,
      // worldEnd: this.data.worldEnd,
    };
  },
  methods: {
    onClose({ target }) {
      if (target.className === "close") {
        this.$emit("close");
      }
    },
  },
  mounted() {
    window.addEventListener("click", this.onClose);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.onClose);
  },
};
</script>

<style scoped lang="less">
.pipe-popup {
  background: url("@/views/home/images/popup-bg2.png") no-repeat center;
  background-size: 100% 100%;
  padding: 10px 10px 50px;
  max-width: 410px;
  position: relative;
  pointer-events: auto;
  translate: 0 -50%;

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    color: #fff;
    cursor: pointer;
  }

  #content {
    margin-top: 10px;
    min-width: 250px;

    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px #fff solid;
      margin-top: -1px;
      white-space: nowrap;

      &-name,
      &-value {
        padding: 5px;
        box-sizing: border-box;
      }

      &-name {
        width: 26%;
        border-right: 1px #fff solid;
        text-align: right;
      }

      &-value {
        width: 74%;
      }
    }
  }

  h3 {
    margin-top: 0;
  }
}
</style>
